import React from 'react';

const MobileJumpBar = ({ sections, activeSection, onSectionClick, readTimes = {} }) => {
  return (
    <div className="sticky top-0 z-10 bg-white border-b border-gray-200 -mx-4 px-4 py-3 mb-6 overflow-x-auto">
      <div className="flex gap-2 min-w-max">
        {sections.map((section) => {
          const isActive = activeSection === section.id;
          const readTime = readTimes[section.id];
          return (
            <button
              key={section.id}
              onClick={() => onSectionClick(section.id)}
              className={`flex-shrink-0 px-4 py-2 text-xs font-medium rounded-full transition-colors ${
                isActive
                  ? 'bg-purple-600 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {section.title}
              {readTime && (
                <span style={{ marginLeft: '6px', opacity: 0.7, fontSize: '10px' }}>
                  {readTime}m
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileJumpBar;
